import React from "react";
import { ButtonGroup, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { UploadIcon } from "@simplex/sx-icons";

interface HeaderToolbarActionsProps {
  showStatusDropdown?: boolean;
  statusValue?: string;
  onStatusChange?: (nextStatus: string) => Promise<void> | void;
  disableFileActions?: boolean;
  isInProjectlist?: boolean;
  buttonTitle?: string;
  onToggleCreate: () => void;
  uploadInputRef: React.RefObject<HTMLInputElement | null>;
  uploadProjectFile?: (files: File) => void;
  renderToolbarActions?: () => React.ReactNode;
  handleDelete?: () => void;
  t: (key: string) => string;
}

function HeaderToolbarActions({
  showStatusDropdown,
  statusValue,
  onStatusChange,
  disableFileActions,
  isInProjectlist,
  buttonTitle,
  onToggleCreate,
  uploadInputRef,
  uploadProjectFile,
  renderToolbarActions,
  handleDelete,
  t,
}: HeaderToolbarActionsProps) {
  return (
    <>
      <ButtonGroup className="float-start ps-2 pt-2">
        {showStatusDropdown && statusValue && onStatusChange && (
          <Form.Select
            size="lg"
            value={statusValue}
            className="ngdropdown"
            style={{ fontSize: 12, width: "inherit", display: "inline-block", cursor: "pointer" }}
            onChange={async (e) => {
              await onStatusChange(e.target.value);
            }}
            title={t("change_status")}
          >
            <option value="active">{t("project.status.active")}</option>
            <option value="inactive">{t("project.status.inactive")}</option>
          </Form.Select>
        )}
      </ButtonGroup>
      <ButtonGroup className="float-end">
        <button
          id="create-new-project-button"
          type="button"
          className="primary-btn d-flex align-items-center gap-1 px-2 py-1"
          disabled={Boolean(disableFileActions)}
          onClick={onToggleCreate}
        >
          <svg style={{ fill: "#fff" }} xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24">
            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
          </svg>
          <span>{buttonTitle}</span>
        </button>

        {!isInProjectlist && (
          <>
            <button
              type="button"
              className="secondary-btn search-toggle-icon"
              title={t("upload_file")}
              style={{ cursor: disableFileActions ? "not-allowed" : "pointer" }}
              disabled={Boolean(disableFileActions)}
              onClick={() => {
                if (disableFileActions) return;
                uploadInputRef.current?.click();
              }}
            >
              <UploadIcon color="currentColor" size={16} />
            </button>
            <input
              ref={uploadInputRef}
              disabled={Boolean(disableFileActions)}
              onClick={(e) => {
                if (disableFileActions) {
                  e.preventDefault();
                  return;
                }
                (e.target as HTMLInputElement).value = "";
              }}
              type="file"
              onChange={(e) => {
                if (disableFileActions) return;
                if (
                  uploadProjectFile &&
                  e.target.files &&
                  e.target.files.length > 0 &&
                  e.target.files[0] !== undefined
                ) {
                  uploadProjectFile(e.target.files[0]);
                }
              }}
              style={{ display: "none" }}
            />
          </>
        )}

        {renderToolbarActions && renderToolbarActions()}

        {handleDelete && (
          <button
            type="button"
            className="add-button d-flex align-items-center gap-1 px-2 py-1"
            title={t("buttons.delete")}
            aria-label={t("buttons.delete")}
            style={{ cursor: "pointer", fontSize: "12px" }}
            onClick={() => {
              handleDelete();
            }}
          >
            <FontAwesomeIcon icon={faTrash} style={{ color: "black" }} />
          </button>
        )}
      </ButtonGroup>
    </>
  );
}

export default HeaderToolbarActions;
